import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import RatesCallout from './RatesCallout'

const MileageRatesCallout = () => {
  const { navigation } = useNavigation()

  return (
    <RatesCallout
      description={i18n.t('expenses_v2.settings.rate_configurations.mileage_callout.description')}
      to={navigation.settings.expenses.mileageRates.fullPath()}
      cta={i18n.t('expenses_v2.settings.rate_configurations.mileage_callout.cta')}
    />
  )
}

export default MileageRatesCallout
